app.controller("welcomeController", [
	"$scope",
	"$rootScope",
	"$state",
	"$modal",
	"UserService",
	"Session",
	"CurrentPatient",
	"AppointmentAPI",
	"PracticeService",
	"uiCalendarConfig",
	"PatientAPI",
	"CALENDAR_SEEN",
	'$filter',
	"ShareData",
	'CALENDAR_CNA_DNA',
	"NotificationService",
	"LegalAgreementService",
	"TIMEZONE_TYPE",
	"NOTIFICATIONS_UPGRADE_1067",
	"$timeout",
	"AppointmentLiveUpdateService",
	"InvoiceLiveUpdateService",
	"ExceptionAPI",
	"SettingsDialog",
	function ($scope, $rootScope, $state, $modal, UserService, Session, CurrentPatient, AppointmentAPI, PracticeService, uiCalendarConfig, PatientAPI, CALENDAR_SEEN, $filter, ShareData, CALENDAR_CNA_DNA, NotificationService, LegalAgreementService, TIMEZONE_TYPE, NOTIFICATIONS_UPGRADE_1067, $timeout, AppointmentLiveUpdateService, InvoiceLiveUpdateService, ExceptionAPI, SettingsDialog) {
		$scope.US = UserService;
		$scope.CP = CurrentPatient;
		$scope.Session = Session;
		$scope.NotificationService = NotificationService;
		$scope.LegalAgreementService = LegalAgreementService;
		$scope.TIMEZONE_TYPE = TIMEZONE_TYPE;
		$scope.notificationsUpgradeEnabled = NOTIFICATIONS_UPGRADE_1067;
		$scope.setPassword = {};
		$scope.setPassword.password = "";
		$scope.setPassword.passwordVerify = "";
		$scope.samePasswordError = false;
		$scope.terms = false;
		$scope.requestPwResetForm = {};
		$scope.isAdminRole = Session.user.roles.includes("ADMIN");
		$scope.showPassword = false;
		$scope.showPassword2 = false;
		$scope.ShareData = ShareData;
		$scope.appointment_categories = [];
		// The appointment dialog's types (its template is the calendar's, where the dialog keeps a list of its
		// own). Here every appointment is the session practice's, so it is that practice's list.
		$scope._appointment_categories = [];

		$rootScope.startIdleTimer();

		const draftIcon = '<svg style="width:1.75em;height:1.75em;margin-left:-1.8rem;margin-top:-0.2rem" viewBox="0 0 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg" stroke=""><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="0" y="0" width="24.00" height="24.00" rx="12" fill="#ffffff" strokewidth="0"/></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <circle opacity="0.5" cx="12" cy="12" r="10" stroke="#ff0000" stroke-width="1.5"/> <path d="M12 6V18" stroke="#ff0000" stroke-width="1.5" stroke-linecap="round"/> <path d="M15 9.5C15 8.11929 13.6569 7 12 7C10.3431 7 9 8.11929 9 9.5C9 10.8807 10.3431 12 12 12C13.6569 12 15 13.1193 15 14.5C15 15.8807 13.6569 17 12 17C10.3431 17 9 15.8807 9 14.5" stroke="#ff0000" stroke-width="1.5" stroke-linecap="round"/> </g></svg>';
		const pendingIcon = '<svg style="width:1.75em;height:1.75em;margin-left:-1.8rem;margin-top:-0.2rem" viewBox="0 0 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg" stroke=""><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="0" y="0" width="24.00" height="24.00" rx="12" fill="#ffffff" strokewidth="0"/></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <circle opacity="0.5" cx="12" cy="12" r="10" stroke="#ffa500" stroke-width="1.5"/> <path d="M12 6V18" stroke="#ffa500" stroke-width="1.5" stroke-linecap="round"/> <path d="M15 9.5C15 8.11929 13.6569 7 12 7C10.3431 7 9 8.11929 9 9.5C9 10.8807 10.3431 12 12 12C13.6569 12 15 13.1193 15 14.5C15 15.8807 13.6569 17 12 17C10.3431 17 9 15.8807 9 14.5" stroke="#ffa500" stroke-width="1.5" stroke-linecap="round"/> </g></svg>';
		const paidIcon = '<svg style="width:1.75em;height:1.75em;margin-left:-1.8rem;margin-top:-0.2rem" viewBox="0 0 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg" stroke=""><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="0" y="0" width="24.00" height="24.00" rx="12" fill="#ffffff" strokewidth="0"/></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <circle opacity="0.5" cx="12" cy="12" r="10" stroke="#008000" stroke-width="1.5"/> <path d="M12 6V18" stroke="#008000" stroke-width="1.5" stroke-linecap="round"/> <path d="M15 9.5C15 8.11929 13.6569 7 12 7C10.3431 7 9 8.11929 9 9.5C9 10.8807 10.3431 12 12 12C13.6569 12 15 13.1193 15 14.5C15 15.8807 13.6569 17 12 17C10.3431 17 9 15.8807 9 14.5" stroke="#008000" stroke-width="1.5" stroke-linecap="round"/> </g></svg>';

		function routeEvent(category) {
			const appointment_categories = $scope.appointment_categories ? $scope.appointment_categories : [];
			const obj = appointment_categories.find((t) => t.category_id === category);
			return obj ? { backgroundColor: `#${obj.colour}`, borderColor: `#${obj.colour}` } : {};
		}

		$scope.resolvePracticeTimezoneName = function () {
			var tzEnum = $scope.Session && $scope.Session.practice && $scope.Session.practice.timezone;

			var candidate = $scope.TIMEZONE_TYPE && $scope.TIMEZONE_TYPE.find(function (z) {
				return z && (z.value === tzEnum || z.name === tzEnum);
			});

			// Check if the mapped name is a valid IANA timezone
			if (candidate && candidate.name && moment.tz.zone(candidate.name)) {
				return candidate.name;
			}

			// Fallback just in case the IANA string is stored in candidate.value instead.
			if (candidate && candidate.value && moment.tz.zone(candidate.value)) {
				return candidate.value;
			}

			// Check if the raw string itself is a valid timezone.
			if (tzEnum && moment.tz && moment.tz.zone(tzEnum)) {
				return tzEnum;
			}

			return 'UTC';
		};

		$scope.dateTimeHandler = function (strDate) {
			return new Date(strDate);
		};

		$scope.formatDateTime = function (strDate) {
			const practiceTimezoneName = $scope.resolvePracticeTimezoneName();
			const localInPractice = moment.utc(strDate).tz(practiceTimezoneName).toDate();
			return new Date(localInPractice);
		}

		this.$onInit = function () {
			$scope.CP.clearPatient();
			$scope.API = AppointmentAPI;
			$scope.PA = PatientAPI;
			$scope.eventSources = [];
			$scope.PracticeAPI = PracticeService;
			$scope.CALENDAR_ENABLE = false;
			$scope.CALENDAR_SEEN = CALENDAR_SEEN;
			$scope.CALENDAR_CNA_DNA = CALENDAR_CNA_DNA;
			$scope.currentSurgeon = { selected: null };
			$scope.allAppointments = [];
			subscribeToLiveAppointmentChanges();
			$scope.selectedDate = { date: $filter("date")(new Date(), "EEE dd/MM/yyyy") };

			// Check for Pending Legal Agreements on Load
			$scope.LegalAgreementService.checkPendingAgreements();

			$scope.$on('legalAgreementsCleared', function () {
				if ($scope.notificationsUpgradeEnabled) {
					NotificationService.loadPending();
				}
			});

			UserService.getUserPractices().then(function (resp) {
				// Always take the fresh list: each practice carries what the user may do there, which
				// changes when their roles do.
				Session.setPracticeOptions(resp.data);
				if (Session.practice) {
					const current = Session.practiceOptions.find(function (practice) {
						return practice.id === Session.practice.id;
					});
					Session.setPractice(current || null);
				}
				$scope.practices = Session.practiceOptions;

				if (Session.practiceOptions.length === 1) {
					Session.setPractice(Session.practiceOptions[0]);
					$scope.US.getUser().then(
						function (resp) {
							Session.setCurrentUser(resp.data);
						},
						function (error) {
							console.log("Unable to load current user", error && error.status);
						}
					);
				}
			});
		};

		function fetchDoctors() {
			if (!Session.practice) {
				return;
			}
			if (Session.practice.practiceFeatures && Session.practice.practiceFeatures.calendarFeature === true) {
				$scope.CALENDAR_ENABLE = true;
			} else {
				$scope.CALENDAR_ENABLE = false;
			}
			if (!$scope.CALENDAR_ENABLE) {
				return;
			}
			$scope.API.getAppointmentUsers().then(
				function (resp) {
					$scope.ophthalmologists = [];
					resp.data.forEach(function (doc) {
						$scope.ophthalmologists.push({ name: doc.firstName + " " + doc.lastName, value: doc.id });
					});
					$scope.ophthalmologists.sort(function (a, b) {
						if (a.name < b.name) {
							return -1;
						}
						if (a.name > b.name) {
							return 1;
						}
						return 0;
					});

					const id = $scope.ShareData.clinicianIdHome ? $scope.ShareData.clinicianIdHome : Session.userId;
					const target = $scope.ophthalmologists.find((t) => t.value == id);
					if (target) {
						$scope.currentSurgeon.selected = target.value;
					} else if ($scope.ophthalmologists.length > 0) {
						$scope.currentSurgeon.selected = $scope.ophthalmologists[0].value;
					} else {
						$scope.currentSurgeon.selected = null;
					}

				},
				function (err) {
					console.log("Unable to load appointment users", err && err.status);
				}
			).then(function () {
				if (!Session.practice) {
					return;
				}
				fetchUserSettings();
				fetchSetting();
			});
		}

		function fetchUserSettings() {
			if (!Session.practice || !Session.practice.id) {
				return;
			}
			$scope.PracticeAPI.isProcessing = true;
			$scope.PracticeAPI.queryCalendarSetting()
				.then(
					function (resp) {
						$scope.appointment_categories = resp.data.appointment_categories;
						$scope._appointment_categories = $scope.appointment_categories || [];
					},
					function (error) {
						console.error("Unable to load calendar settings", error && error.status);
					}
				)
				.then(function () {
					$scope.PracticeAPI.isProcessing = false;
					fetchPatientAppointments();
				});
		}

		let appointmentsRequestId = 0;
		function fetchPatientAppointments() {
			if (!Session.practice || !Session.practice.id) {
				return;
			}
			if (!$scope.calendar_range_start || !$scope.calendar_range_end) {
				return;
			}
			// Date navigation, clinician and practice changes can each start a fetch before the last
			// one returns; only the newest request may draw the calendar.
			const requestId = ++appointmentsRequestId;
			$scope.API.isProcessing = true;
			$scope.API.queryPatientAppointment(
				$scope.currentSurgeon.selected ? $scope.currentSurgeon.selected : Session.userId,
				$scope.calendar_range_start,
				$scope.calendar_range_end,
				Session.practice.id
			)
				.then(
					function (resp) {
						if (requestId !== appointmentsRequestId) {
							return;
						}
						$scope.allAppointments = angular.copy(resp.data);
						renderAppointmentEvents($scope.allAppointments);
					},
					function (error) {
						if (requestId !== appointmentsRequestId) {
							return;
						}
						if ($scope.serverErrorModal) {
							$scope.serverErrorModal.hide();
						}
						// Clear any wording a more specific failure left on the shared modal scope.
						$scope.alertMessage = null;
						$scope.alertDetail = null;
						$scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "CatTrax has encountered an error",
						});
					}
				)
				.then(function () {
					$scope.API.isProcessing = false;
					$scope.loaded = true;
				});
		}

		// Another user's appointment edits, applied to this open calendar as they happen. Only the one
		// changed appointment is fetched, and only when it falls inside what this calendar is showing -
		// see AppointmentLiveUpdateService.
		function subscribeToLiveAppointmentChanges() {
			AppointmentLiveUpdateService.subscribe($scope, {
				appointments: function () {
					return $scope.allAppointments;
				},
				isInView: function (change) {
					// This calendar always shows exactly one clinician - the chosen one, or the signed-in
					// user - which is the same value fetchPatientAppointments() queries with.
					const clinicianId = $scope.currentSurgeon.selected ? $scope.currentSurgeon.selected : Session.userId;
					return AppointmentLiveUpdateService.isWithinCalendarWindow(
						change,
						$scope.calendar_range_start,
						$scope.calendar_range_end,
						clinicianId
					);
				},
				onChanged: function () {
					renderAppointmentEvents($scope.allAppointments);
				},
			});

			// Invoice changes reach this calendar too - the invoice icon on an appointment and the
			// total in its hover are drawn from the summaries attached to it.
			InvoiceLiveUpdateService.subscribeAppointmentInvoices($scope, {
				appointments: function () {
					return $scope.allAppointments;
				},
				onChanged: function () {
					renderAppointmentEvents($scope.allAppointments);
				},
			});
		}

		function getIcon(invoiceList) {
			if (!invoiceList || invoiceList.length === 0) {
				return null;
			}
			if (invoiceList.some((t) => t.status === "DRAFT")) {
				return draftIcon;
			} else if (invoiceList.some((t) => t.status === "SUBMITTED")) {
				return pendingIcon;
			} else if (invoiceList.every((t) => t.status === "PAID")) {
				return paidIcon;
			}
			return null;
		}

		function renderAppointmentEvents(data) {
			const practiceTimezoneName = $scope.resolvePracticeTimezoneName();
			$scope.events = data.map((t) => {
				const startInPracticeTz = moment.utc(t.start_date_utc).tz(practiceTimezoneName);
				const endInPracticeTz = startInPracticeTz.clone().add(t.duration_minutes, "minutes");
				const startLocalNaive = startInPracticeTz.format("YYYY-MM-DDTHH:mm:ss");
				const endLocalNaive = endInPracticeTz.format("YYYY-MM-DDTHH:mm:ss");
				return {
					title: t.patient_name,
					className: "notranslate",
					id: t.patient_appointment_id,
					icon: getIcon(t.invoice_list),
					appointment: { ...t },
					start: startLocalNaive,
					end: endLocalNaive,
					...routeEvent(t.category_id),
				};
			});
			$scope.eventSources = [$scope.events];
			if (uiCalendarConfig.calendars.homeCalendar) {
				uiCalendarConfig.calendars.homeCalendar.fullCalendar("removeEvents");
				uiCalendarConfig.calendars.homeCalendar.fullCalendar("addEventSource", $scope.events);
				uiCalendarConfig.calendars.homeCalendar.fullCalendar("rerenderEvents");
			}
		}

		$scope.getProgressTimestamp = function (key) {
			if ($scope.appointment && $scope.appointment.patient_seen && $scope.appointment.patient_seen[key]) {
				return '(' + $filter("date")(new Date($scope.appointment.patient_seen[`${key}_timestamp`]), "dd/MMM HH:mm") + ')';
			}
			return '';
		}

		function getProgressString(seen) {
			if (!seen) {
				return "";
			}

			let timestamp = null;
			let seen_latest = null;

			if (seen.doctor_started) {
				timestamp = new Date(seen.doctor_started_timestamp);
				seen_latest = 'Doctor started';
			}

			if (seen.doctor_finished) {
				if (!timestamp || moment(seen.doctor_finished_timestamp).isAfter(moment(timestamp))) {
					timestamp = new Date(seen.doctor_finished_timestamp);
					seen_latest = 'Doctor finished';
				}
			}

			if (seen.technician_started) {
				if (!timestamp || moment(seen.technician_started_timestamp).isAfter(moment(timestamp))) {
					timestamp = new Date(seen.technician_started_timestamp);
					seen_latest = 'Technician started';
				}
			}

			if (seen.technician_finished) {
				if (!timestamp || moment(seen.technician_finished_timestamp).isAfter(moment(timestamp))) {
					timestamp = new Date(seen.technician_finished_timestamp);
					seen_latest = 'Technician finished';
				}
			}

			if (seen.nurse_started) {
				if (!timestamp || moment(seen.nurse_started_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'Nurse started';
					timestamp = new Date(seen.nurse_started_timestamp);
				}
			}

			if (seen.nurse_finished) {
				if (!timestamp || moment(seen.nurse_finished_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'Nurse finished';
					timestamp = new Date(seen.nurse_finished_timestamp);
				}
			}

			if (seen.optometrist_started) {
				if (!timestamp || moment(seen.optometrist_started_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'Optometrist started';
					timestamp = new Date(seen.optometrist_started_timestamp);
				}
			}

			if (seen.optometrist_finished) {
				if (!timestamp || moment(seen.optometrist_finished_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'Optometrist finished';
					timestamp = new Date(seen.optometrist_finished_timestamp);
				}
			}

			if (seen.orthoptist_started) {
				if (!timestamp || moment(seen.orthoptist_started_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'Orthoptist started';
					timestamp = new Date(seen.orthoptist_started_timestamp);
				}
			}

			if (seen.orthoptist_finished) {
				if (!timestamp || moment(seen.orthoptist_finished_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'Orthoptist finished';
					timestamp = new Date(seen.orthoptist_finished_timestamp);
				}
			}

			if (seen.arrived) {
				if (!timestamp || moment(seen.arrived_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'Arrived';
					timestamp = new Date(seen.arrived_timestamp);
				}
			}

			if (seen.departed) {
				if (!timestamp || moment(seen.departed_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'Departed';
					timestamp = new Date(seen.departed_timestamp);
				}
			}

			if (seen.could_not_attend) {
				if (!timestamp || moment(seen.could_not_attend_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'CNA';
					timestamp = new Date(seen.could_not_attend_timestamp);
				}
			}

			if (seen.did_not_attend) {
				if (!timestamp || moment(seen.did_not_attend_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'DNA';
					timestamp = new Date(seen.did_not_attend_timestamp);
				}
			}

			if (seen.rebooked) {
				if (!timestamp || moment(seen.rebooked_timestamp).isAfter(moment(timestamp))) {
					seen_latest = 'Rebooked';
					timestamp = new Date(seen.rebooked_timestamp);
				}
			}

			if (seen_latest && timestamp) {
				return `(${seen_latest}: ${$filter("date")(new Date(timestamp), "HH:mm")})`
			}
			return "";
		}

		function selectPatient(patient, appointment) {
			$scope.CP.setPatient(patient, appointment);
			if (!$scope.CP.patientIsMine) {
				$modal({
					controller: "patientTransferController",
					templateUrl: "app/src/views/templates/modal.patient-transfer-flow.tpl.html",
					show: true,
					backdrop: "static",
					resolve: {
						patientId: function () {
							return patient.id;
						},
						// Pass a callback to update the dashboard and redirect on success
						onSuccess: function () {
							return function (updatedPatient) {
								$scope.CP.setPatient(updatedPatient, appointment);
								$state.go("patient-dashboard");
							};
						},
						onCancel: function () {
							return function () { };
						}
					}
				});
			} else {
				$state.go("patient-dashboard");
			}
		}

		$scope.forwardPatientDashboard = function (appointment) {
			$scope.PA.getPatient(appointment.patient_id).then(
				function (resp) {
					selectPatient(resp.data, appointment);
				},
				function (error) {
					if ($scope.serverErrorModal) {
						$scope.serverErrorModal.hide();
					}
					// Clear any wording a more specific failure left on the shared modal scope.
					$scope.alertMessage = null;
					$scope.alertDetail = null;
					$scope.serverErrorModal = $modal({
						scope: $scope,
						templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
						show: true,
						title: "CatTrax has encountered an error",
					});
				}
			);
		};

		function downloadFile(data, filename, mime, bom) {
			var blobData = typeof bom !== "undefined" ? [bom, data] : [data];
			var blob = new Blob(blobData, { type: mime || "application/pdf" });
			if (typeof window.navigator.msSaveBlob !== "undefined") {
				window.navigator.msSaveBlob(blob, filename);
			} else {
				var blobURL = window.URL.createObjectURL(blob);
				var tempLink = document.createElement("a");
				tempLink.style.display = "none";
				tempLink.href = blobURL;
				tempLink.setAttribute("download", filename);
				if (typeof tempLink.download === "undefined") {
					tempLink.setAttribute("target", "_blank");
				}
				document.body.appendChild(tempLink);
				tempLink.click();
				document.body.removeChild(tempLink);
				window.URL.revokeObjectURL(blobURL);
				$scope.displaySpinner = false;
			}
		}

		function getFileName(extension) {
			var theTime = $filter("date")(new Date(), "yyyy-MM-dd@hmma");
			return (
				"CatTrax_appointments_" +
				theTime +
				"." + (extension || "pdf")
			);
		}

		function getAppointmentListRequest(selectedDate) {
			const practiceTimezoneName = $scope.resolvePracticeTimezoneName();
			const events = $scope.events.filter((t) => {
				const inPractice = moment.utc(t.appointment.start_date_utc).tz(practiceTimezoneName);
				return inPractice.format('YYYY-MM-DD') === selectedDate;
			});
			return {
				clinician_id: Number($scope.currentSurgeon.selected),
				appointment_list_items: events.map(t => ({ patient_id: t.appointment.patient_id, appointment_id: t.appointment.patient_appointment_id })),
			};
		}

		function downloadPdf(selectedDate) {
			$scope.API.downloadAppointmentList(getAppointmentListRequest(selectedDate)).then(function (resp) {
				downloadFile(resp.data, getFileName("pdf"), "application/pdf");
			});
		}

		function downloadCsv(selectedDate) {
			$scope.API.downloadAppointmentListCsv(getAppointmentListRequest(selectedDate)).then(function (resp) {
				downloadFile(resp.data, getFileName("csv"), "text/csv;charset=utf-8");
			});
		}

		$scope.eventAfterAllRender = function (view) {
			view.el.find('.fc-widget-header').each(function () {
				const selectedDate = $(this).parent().attr('data-date');
				const downloads = $(
					'<span class="fc-list-heading-alt appointment-list-downloads">' +
						'<a href class="appointment-list-download-csv" title="Download CSV" data-testid="appointment-list-download-csv"><i class="fa-solid fa-file-csv"></i></a>' +
						'<a href class="appointment-list-download-pdf" title="Download PDF" data-testid="appointment-list-download-pdf"><img src="app/build/img/download.svg" alt="Download PDF"></a>' +
					'</span>'
				);
				downloads.find('.appointment-list-download-csv').click(function (event) {
					event.preventDefault();
					event.stopPropagation();
					downloadCsv(selectedDate);
				});
				// The rest of the day header keeps downloading the PDF, as it always has.
				$(this).append(downloads).click(function (event) {
					event.preventDefault();
					event.stopPropagation();
					downloadPdf(selectedDate);
				});
			})
		}

		function renderInvoiceDetail(invoiceList) {
			let result = '';
			if (invoiceList) {
				invoiceList.forEach(t => { result += `<p>$${t.total} - ${t.status}</p>` });
			}
			return `<div>${result}</div>`;
		}

		function removePopup() {
			var popups = document.querySelectorAll(".popover");
			if (popups) {
				for (var i = 0; i < popups.length; i++) {
					var popup = popups[i];
					var popupElement = angular.element(popup);
					const popupScope = popupElement.scope();
					if (popupScope && popupScope.$parent) {
						popupScope.$parent.isOpen = false;
					}
					popupElement.remove();
				}
			}
		}

		$scope.eventMouseout = function (event, jsEvent, view) {
			removePopup();
		}

		$scope.eventRender = function (eventObj, $el, view) {
			if (!eventObj.appointment) {
				return;
			}

			if (eventObj) {
				let element = $el.find(".fc-list-item-title");
				if (element.length === 0) {
					element = $el.find(".fc-title");
				}

				const category = $scope.appointment_categories.find(t => t.category_id === eventObj.appointment.category_id);
				// Patient and category names are user-entered, so they are set as text, never parsed as HTML.
				element[0].textContent = `${eventObj.title} ${getProgressString(eventObj.appointment.patient_seen)} ${category ? ' [' + category.name + ']' : ''}`;

				element.attr("style", "font-family:'Gordita Regular';text-decoration: underline;cursor: pointer; display:flex; padding-left:24px").click(function (event) {
					event.preventDefault();
					event.stopPropagation();
					$scope.forwardPatientDashboard(eventObj.appointment);
				});
				removePopup();
				if (eventObj.icon) {
					$el.find(".fc-list-item-title").prepend(eventObj.icon);
					$el.popover({
						// html: true applies to the title too, so the patient name is escaped.
						title: $("<div>").text(eventObj.title || "").html(),
						content: $(renderInvoiceDetail(eventObj.appointment.invoice_list)),
						trigger: 'hover',
						placement: 'top',
						container: 'body',
						html: true
					});
				}

				const timeElement = $el.find(".fc-list-item-time");
				if (timeElement) {
					timeElement.attr("style", "cursor: pointer");
				}
			}
		};

		$scope.closeDetailsModal = function () {
			if ($scope.appointment_clone && $scope.appointment.patient_appointment_id) {
				const event = $scope.events.find((t) => t.appointment.patient_appointment_id === $scope.appointment.patient_appointment_id);
				if (event) {
					event.appointment = $scope.appointment_clone;
				}
			}
			$scope.detailsModal.hide();
		}

		$scope.alertOnEventClick = function (data, jsEvent, view) {
			const event = $scope.events.find((t) => t.id === data.id);
			$scope.appointment = event.appointment;

			const practiceTimezoneName = $scope.resolvePracticeTimezoneName();
			const appointmentMoment = moment.utc($scope.appointment.start_date_utc).tz(practiceTimezoneName);

			//$scope.appointment._startTime = new Date(1970, 0, 1, appointmentMoment.hour(), appointmentMoment.minute(), 0);

			const businessStartMoment = appointmentMoment.clone().hour(7).minute(0);
			const businessEndMoment = appointmentMoment.clone().hour(22).minute(0);
			generateTimeSlots(businessStartMoment, businessEndMoment);
			$scope.appointment.selectedTimeSlot = appointmentMoment.format('HH:mm');
			$scope.appointment._startDateStr = $filter("date")(appointmentMoment.toDate(), "dd/MM/yyyy");

			$scope.appointment_clone = angular.copy(event.appointment);
			// A type that isn't one of this practice's - saved before the calendar stopped offering another
			// practice's types - is cleared, so the dialog asks for one instead of keeping it out of sight.
			// Cancel puts the appointment back from the clone.
			if ($scope._appointment_categories.length
				&& !$scope._appointment_categories.some((t) => t.category_id === $scope.appointment.category_id)) {
				$scope.appointment.category_id = null;
			}
			fetchAppointmentAudit($scope.appointment.patient_appointment_id);
			// A cooldown may already be part-way through from an earlier send.
			scheduleManualReminderCooldownExpiry();
			$scope.practiceName = $scope.Session.practice.name;
			$scope.detailsModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.appointment-detail.tpl.html",
				show: true,
				backdrop: "static",
				title: "Schedule Appointment",
			});
			return false;
		};

		$scope.deleteAppointment = function (obj) {
			$scope.API.isProcessing = true;

			$scope.API.deleteAppointment(obj.patient_id, obj.patient_appointment_id)
				.then(
					function (resp) {
						fetchPatientAppointments();
					},
					function (error) { }
				)
				.then(function () {
					$scope.API.isProcessing = false;
					if ($scope.detailsModal) {
						$scope.detailsModal.hide();
					}
				});
		};

		// dd/MM/yyyy => yyyy-MM-dd
		const convertDateFormat = (original) => {
			const [day, month, year] = original.split("/");
			return `${year}-${month}-${day}`;
		};

		// The read-only summary in the appointment details modal is derived from the
		// date/time currently selected in the form, so it populates for every way the
		// modal is opened and stays correct when either field is changed.
		$scope.formatAppointmentStart = function (appointment, format) {
			if (!appointment || !appointment._startDateStr || !appointment.selectedTimeSlot) {
				return "";
			}
			const start = moment(
				`${convertDateFormat(appointment._startDateStr)}T${appointment.selectedTimeSlot}`
			);
			return start.isValid() ? start.locale("en").format(format) : "";
		};

		// The API writes `date_created` as a Pacific/Auckland wall-clock timestamp with
		// no offset, so it has to be read back in that zone before being re-displayed in
		// the practice's own timezone.
		$scope.formatAppointmentBookedAt = function (appointment) {
			if (!appointment || !appointment.date_created) {
				return "";
			}
			const bookedAt = moment.tz(appointment.date_created, "Pacific/Auckland").tz($scope.resolvePracticeTimezoneName());
			return bookedAt.isValid() ? bookedAt.locale("en").format("DD/MM/YYYY h:mm A") : "";
		};

		$scope.saveAppointment = function (valid) {
			if (valid) {
				$scope.API.isProcessing = true;
				if ($scope.appointment.selectedTimeSlot) {
					const practiceTimezoneName = $scope.resolvePracticeTimezoneName();
					const originalPractice = moment.utc(convertDateFormat($scope.appointment._startDateStr)).tz(practiceTimezoneName);
					const datePart = originalPractice.format("YYYY-MM-DD");
					const timePart = $scope.appointment.selectedTimeSlot; //moment($scope.appointment.selectedTimeSlot).format("HH:mm");
					const zoned = moment.tz(`${datePart}T${timePart}`, practiceTimezoneName);
					$scope.appointment.start_date_utc = zoned.utc().toISOString();
				}
				if ($scope.appointment.patient_appointment_id) {
					$scope.API.updateAppointment(
						$scope.appointment.patient_id,
						$scope.appointment.patient_appointment_id,
						$scope.appointment
					)
						.then(
							function (resp) {
								fetchPatientAppointments();
							},
							function (error) { }
						)
						.then(function () {
							$scope.API.isProcessing = false;
							if ($scope.detailsModal) {
								$scope.detailsModal.hide();
							}
						});
					return;
				}

				$scope.API.bookAppointment($scope.appointment)
					.then(
						function (resp) {
							fetchPatientAppointments();
						},
						function (error) { }
					)
					.then(function () {
						$scope.API.isProcessing = false;
						if ($scope.detailsModal) {
							$scope.detailsModal.hide();
						}
					});
			} else {
				console.log("invalid form");
			}
		};

		$scope.onPatientSeenChange = function (item) {
			if ($scope.appointment.patient_seen[item]) {
				$scope.appointment.patient_seen[`${item}_timestamp`] = new Date().toISOString();
			} else {
				$scope.appointment.patient_seen[`${item}_timestamp`] = null;
			}
			if (!$scope.appointment.patient_seen.could_not_attend && !$scope.appointment.patient_seen.did_not_attend) {
				$scope.appointment.patient_seen.rebooked_timestamp = null;
				$scope.appointment.patient_seen.rebooked = false;
			}
		}

		$scope.onCategoryChange = function () {
			if (!$scope.appointment.category_id) {
				return;
			}
			const obj = $scope.appointment_categories.find(t => t.category_id === $scope.appointment.category_id);
			if (obj) {
				$scope.appointment.duration_minutes = obj.duration;
			}
		}

		$scope.onSurgeonChange = function () {
			if ($scope.currentSurgeon.selected) {
				fetchPatientAppointments();
				$scope.ShareData.setHomeclinicianId($scope.currentSurgeon.selected);
			}
		};

		$scope.onDateChange = function () {
			uiCalendarConfig.calendars.homeCalendar.fullCalendar('gotoDate', moment($scope.selectedDate.date, 'DD/MM/YYYY'));
		}

		$scope.prevDate = function () {
			$scope.selectedDate.date = $filter("date")(moment($scope.selectedDate.date, "DD/MM/YYYY").add(-1, 'days').toDate(), "EEE dd/MM/yyyy");
			$scope.onDateChange();
		}

		$scope.nextDate = function () {
			$scope.selectedDate.date = $filter("date")(moment($scope.selectedDate.date, "DD/MM/YYYY").add(1, 'days').toDate(), "EEE dd/MM/yyyy");
			$scope.onDateChange();
		}

		function viewRender(view, element) {
			$scope.ShareData.setHomeDefaultDate(view.start.format());
			const practiceTimezoneName = $scope.resolvePracticeTimezoneName();
			const practiceStart = moment(view.start).tz(practiceTimezoneName).startOf('day');
			const practiceEnd = moment(view.end).tz(practiceTimezoneName).startOf('day');

			$scope.calendar_range_start = practiceStart.clone().utc().toISOString();
			$scope.calendar_range_end = practiceEnd.clone().utc().toISOString();

			$scope.selectedDate.date = $filter("date")(practiceStart.toDate(), "EEE dd/MM/yyyy");
			fetchPatientAppointments();
		}

		$scope.uiConfig = {
			calendar: {
				editable: false,
				nowIndicator: true,
				selectable: false,
				selectHelper: true,
				header: {
					left: "title",
					center: "",
					right: "",
				},
				titleFormat: ' ',
				defaultView: "listDay",
				defaultDate: $scope.ShareData.savedCalendarFilters?.homeDate || new Date(),
				listDayAltFormat: "MMMM DD YYYY",
				eventClick: $scope.alertOnEventClick,
				eventMouseout: $scope.eventMouseout,
				eventRender: $scope.eventRender,
				eventAfterAllRender: $scope.eventAfterAllRender,
				businessHours: {
					dow: [1, 2, 3, 4, 5],
					start: "8:00",
					end: "18:00",
				},
				slotDuration: "00:10:00",
				minTime: "07:00:00",
				maxTime: "19:00:00",
				allDaySlot: false,
				eventLimitText: "More",
				eventLimit: 3,
				viewRender: viewRender,
			},
		};

		$scope.toggleShowPassword = function () {
			$scope.showPassword = !$scope.showPassword;
		};

		$scope.toggleShowPassword2 = function () {
			$scope.showPassword2 = !$scope.showPassword2;
		};

		$scope.$watch(
			"Session",
			function (newValue, oldValue) {
				if (Session.user.firstName !== undefined) {
					$scope.firstName = Session.user.firstName;
				}
			},
			true
		);

		// The practice <select> sits inside an ng-if (its own child scope), so its selectedPractice
		// never reaches this scope, and the single-practice path sets the practice without it.
		// Follow the session's practice instead so the calendar loads in both cases.
		$scope.$watch(
			function () {
				return Session.practice && Session.practice.id;
			},
			function (newValue) {
				if (newValue) {
					fetchDoctors();
				}
			}
		);

		$scope.getStarted = function () {
			$scope.CP.clearPatientResult();
			$state.go("patient-dashboard");
		};

		$scope.goAdminPractice = function () {
			$state.go("admin-console", {
				type: "practice",
			});
		};

		$scope.goAdminUser = function () {
			$state.go("admin-console", {
				type: "user",
			});
		};

		$scope.goAdminNotification = function () {
			$state.go("admin-console", {
				type: "notification",
			});
		};

		$scope.goAdminAiAgents = function () {
			$state.go("admin-console", {
				type: "aiAgents",
			});
		};

		$scope.goAdminLegalAgreements = function () {
			$state.go("admin-console", {
				type: "legalAgreement",
			});
		};

		$scope.goAdminPermissions = function () {
			$state.go("admin-console", {
				type: "permissions",
			});
		};

		$scope.goAdminPermissionRefusals = function () {
			SettingsDialog.openPermissionAuditLog();
		};

		$scope.goErrorDashboard = function () {
			$state.go("error-dashboard");
		};

		$scope.appointmentAuditList = [];

		$scope.utc2local = function (utc) {
			const practiceTimezoneName = $scope.resolvePracticeTimezoneName();
			return $filter("date")(moment.utc(utc).tz(practiceTimezoneName).toDate(), "dd/MM/yyyy HH:mm");
		}

		function fetchAppointmentAudit(appointmentId) {
			$scope.appointmentAuditList = [];
			$scope.API.getReminderAudit(appointmentId).then(function (response) {
				$scope.appointmentAuditList = response.data;
				$scope.appointmentAuditList.sort((a, b) => moment.utc(a.reminder_sent_time_UTC).valueOf() - moment.utc(b.reminder_sent_time_UTC).valueOf());
			})
		}

		$scope.sendManualReminder = function (patient_appointment_id, patient_id) {
			$scope.API.isProcessing = true;
			$scope.API.sendReminder(patient_appointment_id, patient_id)
				.then(
					function () {
						// The server stamps previous_manual_reminder_time_UTC on the appointment when it
						// sends. Mirror it locally (on the clone too, since closeDetailsModal restores it)
						// so the 10 minute cooldown starts without having to refetch the appointment.
						const sentAtUTC = moment.utc().format("YYYY-MM-DDTHH:mm:ss");
						$scope.appointment.previous_manual_reminder_time_UTC = sentAtUTC;
						if ($scope.appointment_clone) {
							$scope.appointment_clone.previous_manual_reminder_time_UTC = sentAtUTC;
						}
						scheduleManualReminderCooldownExpiry();
						fetchAppointmentAudit(patient_appointment_id);
					},
					function (error) {
						// A reminder usually fails because the patient's email address or mobile number is
						// wrong or missing - something the person looking at the screen can go and fix - so
						// they get told that, with the server's own reason underneath, rather than the
						// generic "unable to process your request" wording.
						$scope.alertMessage = "The reminder could not be sent. Check the patient's email address and mobile number, then try again.";
						$scope.alertDetail = ExceptionAPI.serverMessage(error);
						$scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "Reminder not sent",
						});
					}
				)
				.then(function () {
					$scope.API.isProcessing = false;
				});
		}

		$scope.getAppointmentType = function () {
			if ($scope.settingOptions) {
				const target = $scope.settingOptions.find((t) => t.appointment_category_id === $scope.appointment.category_id);
				if (target && (target.email_reminders_enabled || target.sms_reminders_enabled)) {
					return false;
				} else {
					return true;
				}
			}
			return false;
		};

		// Mirrors the server side cooldown, which rejects a manual reminder sent within
		// 10 minutes of the appointment's previous_manual_reminder_time_UTC.
		const MANUAL_REMINDER_COOLDOWN_MS = 1000 * 60 * 10;
		let manualReminderCooldownTimer = null;

		function manualReminderCooldownRemainingMs() {
			const previousReminderUTC = $scope.appointment && $scope.appointment.previous_manual_reminder_time_UTC;

			if (!previousReminderUTC) {
				return 0;
			}

			return Math.max(0, MANUAL_REMINDER_COOLDOWN_MS - (new Date() - moment.utc(previousReminderUTC).toDate()));
		}

		// Wake up once, at the moment the cooldown expires, rather than polling on an
		// interval. The $timeout runs a digest, which re-evaluates ng-disabled and
		// re-enables the button on its own - one digest instead of one per tick.
		function scheduleManualReminderCooldownExpiry() {
			$timeout.cancel(manualReminderCooldownTimer);
			manualReminderCooldownTimer = null;

			const remaining = manualReminderCooldownRemainingMs();
			if (remaining > 0) {
				manualReminderCooldownTimer = $timeout(angular.noop, remaining + 250);
			}
		}

		$scope.isManualReminderDisabled = function () {
			return manualReminderCooldownRemainingMs() > 0;
		};

		$scope.$on("$destroy", function () {
			$timeout.cancel(manualReminderCooldownTimer);
		});

		$scope.isManualReminderShow = function () {
			const practiceFeatures = Session.practice.practiceFeatures;
			if ($scope.appointment && $scope.appointment.patient_appointment_id && practiceFeatures && (practiceFeatures.appointmentEmailReminderFeature || practiceFeatures.appointmentSMSReminderFeature)) {
				return true;
			}
			return false;
		}

		$scope.settingOptions = [];
		function fetchSetting() {
			$scope.settingOptions = [];
			$scope.API.isProcessing = true;
			$scope.API.getAppointmentReminderSetting($scope.Session.user.id)
				.then(
					function (response) {
						if (response.data && response.data.category_reminder_settings) {
							$scope.settingOptions = response.data.category_reminder_settings;
						}
					},
					function (error) {
						console.log("Unable to load reminder settings", error && error.status);
					}
				)
				.then(() => ($scope.API.isProcessing = false));
		}

		function generateTimeSlots(minTime, maxTime) {
			const slots = [];
			const interval = 5;

			let currentTime = minTime.clone();
			const endTime = maxTime;

			while (currentTime.valueOf() <= endTime.valueOf()) {
				slots.push({
					display: currentTime.locale('en').format('h:mm a'),
					value: currentTime.format('HH:mm')
				});

				currentTime.add(interval, 'minutes');
			}

			$scope.timeSlots = slots;
		}
	},
]);